import { render } from "./HumorEmojis.vue?vue&type=template&id=9221ae10"
import script from "./HumorEmojis.vue?vue&type=script&lang=js"
export * from "./HumorEmojis.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/Frontend_PsicoApp/Frontend_PsicoApp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__